
import { 
    GET_NOTIFICATION,
    GET_NOTIFICATION_SUCCESS,
    GET_NOTIFICATION_FAIL, 
    GET_NOTIFICATION_RESET,
} from "../actions/getNotificationAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getNotificationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTIFICATION:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_NOTIFICATION_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_NOTIFICATION_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_NOTIFICATION_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getNotificationsReducer;
